import React, { Fragment } from "react";
import { Sparkles, Mail, MapPin, Globe, X } from "./Icons";

const ContactModal = ({ isOpen, onClose, mobile, countryCode }) => {
  if (!isOpen) return null;

  return (
    // <div className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300">
    <div
      className="fixed inset-0 flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300"
      style={{ zIndex: "100" }}
    >
      {/* <div className="glass w-full h-full md:max-w-4xl md:max-h-[85vh] md:rounded-[2.5rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"> */}
      <div
        className="glass w-full h-full md:max-w-4xl md:max-h-[85vh] rounded-[2rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"
        // style={{ padding: mobile ? "" : "3rem" }}
      >
        <div className="px-6 py-4 md:px-8 md:py-6 border-b border-white/5 flex justify-between items-center bg-slate-900/40">
          <div className="flex items-center gap-3">
            <div className="md:w-10 md:h-10 bg-indigo-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/20">
              <Mail className="text-white w-6 md:h-6" />
            </div>
            <h2 className="text-xl font-bold text-white tracking-tight">Contact Us</h2>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-all">
            <X className="md:h-6 w-6 text-slate-400" />
          </button>
        </div>

        <div className={`flex-1 overflow-y-auto ${mobile ? "md:p-4" : "md:p-10"} space-y-12`}>
          <section className="space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-sm font-medium">
              <Mail className="w-4 md:h-4" />
              <span>Get in Touch</span>
            </div>
            <h1 className="text-4xl md:text-5xl text-white font-bold tracking-tight">
              We're here to <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-emerald-400">
                Help.
              </span>
            </h1>
            <p className="text-lg text-slate-400 leading-relaxed max-w-2xl">
              Have questions about your masterpiece or our technology? Please note that all our
              communications are conducted online to ensure efficiency and precision.
            </p>
          </section>

          <div className="grid md:grid-cols-2 gap-6" style={{ margin: mobile ? "1rem" : "2rem" }}>
            {/* <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700"> */}
            <div
              className="rounded-3xl bg-slate-800/50 border border-slate-700"
              style={{ padding: mobile ? "1rem" : "2rem" }}
            >
              <div className="w-12 h-12 bg-indigo-500/10 rounded-xl flex items-center justify-center mb-6">
                <MapPin className="w-6 md:h-6 text-indigo-400" />
              </div>
              <h3 className="text-xl text-white font-bold mb-4">Our Office</h3>
              <address className="text-slate-400 not-italic leading-relaxed text-sm">
                {countryCode !== "IN" ? (
                  <Fragment>
                    <br></br>
                    <span>Composz LLC,</span>
                    <br></br>
                    <span>#121 Haut Brion Ave,</span>
                    <br></br>
                    <span>Newark, </span>
                    <br></br>
                    <span>DE - 19702</span>
                    <br></br>
                    <br></br>
                    <span>Email: team@aicomposz.com</span>
                    <br></br>
                  </Fragment>
                ) : (
                  <Fragment>
                    <br></br>
                    <span>LIFE COLORS</span>
                    <br></br>
                    <span> #9, 4th Cross,</span>
                    <br></br>
                    <span>Kothanur Main Road,</span>
                    <br></br>
                    <span>Bangalore 560 062.</span>
                    <br></br>
                    <br></br>
                    <span>Email: team@aicomposz.com</span>
                    <br></br>
                    <span>Phone Number: 990 2308 960</span>
                  </Fragment>
                )}
              </address>
            </div>

            {/* <div className="p-8 rounded-3xl bg-slate-800/50 border border-slate-700"> */}
            <div
              className="rounded-3xl bg-slate-800/50 border border-slate-700"
              style={{ padding: mobile ? "1rem" : "2rem" }}
            >
              <div className="w-12 h-12 bg-emerald-500/10 rounded-xl flex items-center justify-center mb-6">
                <Globe className="w-6 md:h-6 text-emerald-400" />
              </div>
              <h3 className="text-xl text-white font-bold mb-4">Online Support</h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                To provide the best possible service, we handle all inquiries through our digital
                channels only. This allows our team to review technical details and provide accurate
                responses. You can use 'Contact Us' form at the bottom of our home page to send us
                your enquiries.
              </p>
            </div>
          </div>

          <section className="pt-6 text-center">
            {/* <div className="p-10 rounded-[2.5rem] bg-slate-800/40 border border-white/5 relative overflow-hidden"> */}
            <div
              className="rounded-[2rem] bg-slate-800/40 border border-white/5 relative overflow-hidden"
              style={{ padding: mobile ? "1rem" : "2rem" }}
            >
              {/* <div className="absolute top-0 right-0 p-8 opacity-5"> */}
              <div
                className="absolute top-0 opacity-1"
                style={{ padding: "1rem", display: "flex", justifyContent: "end" }}
              >
                <Sparkles className="w-100 h-100 text-white" />
              </div>
              <p className="text-slate-400 max-w-2xl mx-auto leading-relaxed text-sm">
                Please note that all communications are conducted online. We strive to respond to
                all inquiries as early as possible during our business hours.
              </p>
            </div>
          </section>
        </div>

        <div className="px-6 py-6 md:px-8 md:py-6 border-t border-white/5 bg-slate-900/80 flex justify-end">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs tracking-widest rounded-xl shadow-lg transition-all active:scale-95"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
